import axios from 'axios';

//기타 공통 store
const commonStore = {
    state: {
      itsmInfo: [],
      itsmInfoOrigin: [],
  
      isAlertOpen: false,
      alertStatus: '',
      alertTitle: '',
      alertContent: [],
      confirmCallback: '',
      confirmParameter: {},
  
      noticeInfo: [],
      noticeInfoOrigin: [],
      uploadImageUrl: '',
  
      dentalFormInfo: [],

      statusInfo: [],

      regionInfo: [],
      hospitalInfo: [],

      allRequestDB: [],
      requestDB: [],

      period: null,

      isLoading: false,

      dentalFormSearchText: '',
    },
  
    mutations: {
      setItsmInfo(state, data) {
        data = data.sort((a, b) => {return b._id - a._id;}); // _id 값으로 내림차순 정렬
        state.itsmInfo = data;
        state.itsmInfoOrigin = data;
      },
  
      toggleAlert(state){
        state.isAlertOpen = !state.isAlertOpen;
      },
  
      setAlert(state, data){
        state.alertStatus = data.alertStatus;
        state.alertTitle = data.alertTitle;
        state.alertContent = data.alertContent.split('|');
        state.isAlertOpen = true;
        state.confirmCallback = data.callback;
        state.confirmParameter = data.parameter;
      },
  
      //공지사항 정보 바인딩
      setNoticeInfo(state, data){
        data = data.sort((a, b) => b._id - a._id);
        state.noticeInfo = data.filter((a) => {return a.isPublish && a.kind == '1' && new Date(a.start_dt) <= new Date() && new Date() <= new Date(a.end_dt)});
        state.noticeInfoOrigin = data;
      },

      //공지사항 업로드 이미지 바인딩
      setUploadImage(state, data) {
        state.uploadImageUrl = data;
      },

      //공지사항 업로드 이미지 조회
      getUploadNoticeImageUrl(state) {
        return state.uploadImageUrl;
      },
  
      //치과청구확인서 조회
      setDentalFormInfo(state, data){
        state.dentalFormInfo = data;
      },

      //상태 정보 조회
      setStatusInfo(state, data){
        state.statusInfo = data.content;
      },

      //지역 정보 조회
      getRegionInfo(state, data){
        state.regionInfo = data ? data.content : [];
      },

      //치과 정보 조회
      getHospitalInfo(state, data){
        state.hospitalInfo = data ? data.content : [];
      },

      //치과 DB 요청 및 할당 현황 조회
      getAllRequestDB(state, data){
        data.sort((a, b) => {
          if(+(b.count) > +(a.count)) return 1;
          if(b.planner > a.planner) return 1;
          return 0;
        });

        state.allRequestDB = data;
      },

      //치과 DB 요청 건수 조회
      getRequestDB(state, data){
        state.requestDB = data;
      },
    },
  
    actions: {
      //ITSM 정보 조회
      async getItsmInfo(context) {
        axios.get(`/itsm/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
          .then((res) => {
            context.commit('setItsmInfo', res.data);
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '개선 요청 정보 조회'
                                          ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //ITSM 정보 입력
      async insertItsmInfo(context, data) {
        axios.post(`/itsm/insert`, {  'title': data.title
                                      ,'content': data.content
                                      ,'req_user': data.req_user
                                      ,'insert_date': data.insert_date
                                      ,'insert_id': data.insert_id
                                    }, {
                                      headers: {
                                                  'Authorization': context.rootGetters.getCryptNum
                                      }
                                    })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '개선 요청 정보 입력'
                                            ,'alertContent': res.data.message});
              context.dispatch('getItsmInfo');
            }else if(res.data.result == 'fail'){
              //alert(res.data.message);
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '개선 요청 정보 입력'
                                            ,'alertContent': res.data.message});
            }else{
              //alert('입력 시 오류 발생.\n관리자 문의 필요');
              context.commit('setAlert', {  'alertStatus': 'error'
                                            ,'alertTitle': '개선 요청 정보 입력'
                                            ,'alertContent': '입력 시 오류 발생|관리자 문의 필요'});
            }
          })
          .catch((error) => {
            //console.log(error);
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '개선 요청 정보 입력'
                                          ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //ITSM 완료 처리
      async completeItsmInfo(context, data){
        axios.post(`/itsm/complete`, { '_id': data.id
                                        ,'complete': data.complete
                                        ,'reply': data.reply
                                        ,'complete_date': data.complete_date
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result == 'success'){
            context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '개선 요청 완료 처리'
                                            ,'alertContent': res.data.message});
            context.dispatch('getItsmInfo');
          }else if(res.data.result == 'fail'){
            context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '개선 요청 완료 처리'
                                            ,'alertContent': res.data.message});
          }else{
            //alert('입력 시 오류 발생.\n관리자 문의 필요');
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '개선 요청 완료 처리'
                                          ,'alertContent': '입력 시 오류 발생|관리자 문의 필요'});
          }
        })
        .catch((error) => {
          //console.log(error);
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '개선 요청 완료 처리'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //ITSM 정보 삭제
      async deleteItsmInfo(context, data) {
        axios.post(`/itsm/delete`, { '_id': data.id }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '개선 요청 정보 삭제'
                                            ,'alertContent': res.data.message});
              context.dispatch('getItsmInfo');
            }
          })
          .catch((error) => {
            //alert(`오류 발생: ${error}`);
            context.commit('setAlert', {  'alertStatus': 'error'
                                            ,'alertTitle': '개선 요청 정보 삭제'
                                            ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //ITSM 정보 수정
      async updateItsmInfo(context, data) {
        axios.post(`/itsm/update`, {'_id': data.id
                                    ,'title': data.title
                                    ,'content': data.content
                                    ,'req_user': data.req_user
                                    ,'update_id': data.insert_id
                                    ,'update_date': data.insert_date
                                    ,'reply': data.reply
                                    }, {
                                      headers: {
                                                  'Authorization': context.rootGetters.getCryptNum
                                      }
                                    })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '개선 요청 정보 수정'
                                            ,'alertContent': res.data.message});
              context.dispatch('getItsmInfo');
            }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                            ,'alertTitle': '개선 요청 정보 수정'
                                            ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //공지사항 정보 조회
      async getNoticeInfo(context) {
        axios.get('/notice/list', {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setNoticeInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `공지사항 정보 조회`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //공지사항 정보 입력
      async insertNotice(context, data){
        axios.post(`/notice/insert`, {  'title': data.title
                                        ,'content': data.content
                                        ,'isPublish': data.isPublish
                                        ,'kind': data.kind
                                        ,'start_dt': data.start_dt
                                        ,'end_dt': data.end_dt
                                        ,'insert_dt': data.insert_dt
                                        ,'insert_id': data.insert_id
                                        ,'insert_name': data.insert_name
                                      }, {
                                        headers: {
                                                    'Authorization': context.rootGetters.getCryptNum
                                        }
                                      })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `공지사항 정보 입력`
                                        ,'alertContent': res.data.message});
          context.dispatch('getNoticeInfo');
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `공지사항 정보 입력`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //공지사항 정보 수정
      async updateNotice(context, data){
        axios.post(`/notice/update`, {  '_id': data.id
                                        ,'title': data.title
                                        ,'content': data.content
                                        ,'isPublish': data.isPublish
                                        ,'kind': data.kind
                                        ,'start_dt': data.start_dt
                                        ,'end_dt': data.end_dt
                                        ,'update_dt': data.update_dt
                                        ,'update_id': data.update_id
                                        ,'update_name': data.update_name
                                      }, {
                                        headers: {
                                                    'Authorization': context.rootGetters.getCryptNum
                                        }
                                      })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `공지사항 정보 수정`
                                        ,'alertContent': res.data.message});
          context.dispatch('getNoticeInfo');
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `공지사항 정보 수정`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //공지사항 정보 삭제
      async deleteNotice(context, data){
        axios.post(`/notice/delete`, {
                                        '_id': data.id
                                      }, {
                                        headers: {
                                                    'Authorization': context.rootGetters.getCryptNum
                                        }
                                      })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `공지사항 정보 삭제`
                                        ,'alertContent': res.data.message});
          context.dispatch('getNoticeInfo');
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `공지사항 정보 삭제`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //공지사항 이미지 업로드
      async uploadNoticeImage(context, data) {
        const formData = new FormData();
        formData.append('image', data.blob);

        // 서버로 이미지를 업로드하고 URL을 받아오는 로직
        // 아래 URL은 예시이며, 실제 업로드 로직에 맞게 수정해야 합니다.
        await axios.post(`/notice/upload/image`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': context.rootGetters.getCryptNum
            }
        }).then(res => {
          context.commit('setUploadImage', res.data.imageUrl);
        }).catch(error => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `공지사항 이미지 업로드`
                                        ,'alertContent': `오류 발생|${error}`});
        });
      },
  
      //첨부파일 저장
      async uploadFile(context, data){
        const formData = new FormData();
        for (let i = 0; i < data.file.length; i++) {
          formData.append('files', data.file[i]);
        }
        await axios.post(`/uploadFile`, formData, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `첨부파일 저장`
                                        ,'alertContent': res.data.message});
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `첨부파일 저장`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //첨부파일 다운로드
      async downloadFile(context, data){
        axios.get(`/downloadFile`, {
                                      params: {
                                        key: data
                                      },
                                      responseType: 'blob'
                                    }, {
                                      headers: {
                                                  'Authorization': context.rootGetters.getCryptNum
                                      }
                                    })
        .then(response => {
          const contentDisposition = response.headers.get('Content-Disposition');
          const filename = contentDisposition ? decodeURIComponent(contentDisposition.split('filename=')[1]) : 'downloadedFile';
          const blob = response.data;
          return { filename, blob };
        })
        .then(({ filename, blob }) => {
          const url = URL.createObjectURL(blob);
          
          // 다운로드 링크 생성
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          
          // 링크 클릭하여 다운로드 시작
          link.click();
          
          // 더 이상 필요 없는 URL 객체 제거
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `첨부파일 다운로드`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //치과청구확인서 조회
      async getDentalForm(context){
        axios.get(`/dentalForm/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setDentalFormInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '치과청구확인서 조회'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //치과청구확인서 삭제
      async deleteDentalForm(context, data){
        axios.post(`/dentalForm/delete`, {_id: data.id, key: data.key}, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result == 'success'){
            context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '치과청구확인서 삭제'
                                            ,'alertContent': res.data.message});
            context.dispatch('getDentalForm');
          }
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '치과청구확인서 삭제'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //치과청구확인서 업로드
      async uploadDentalForm(context, data){
        let formData = new FormData();
        const file = data.dentalForm[0];
        formData.append('file', file, encodeURIComponent(file.name));
        formData.append('file_name', encodeURIComponent(file.name));
        formData.append('insert_date', new Date().toLocaleDateString());
        formData.append('insert_id', this.state.login.loginID);
  
        axios.post(`/dentalForm/upload`, formData, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result == 'success'){
            context.dispatch('getDentalForm');
          }
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '치과청구확인서 업로드'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //치과청구확인서 다운로드
      async downloadDentalForm(context, data){
        axios.get(`/dentalForm/download`, {
                                      params: {
                                        key: data
                                      },
                                      responseType: 'blob'
                                    }, {
                                      headers: {
                                                  'Authorization': context.rootGetters.getCryptNum
                                      }
                                    })
        .then(response => {
          const contentDisposition = response.headers.get('Content-Disposition');
          const filename = contentDisposition ? decodeURIComponent(contentDisposition.split('filename=')[1]) : 'downloadedFile';
          const blob = response.data;
          return { filename, blob };
        })
        .then(({ filename, blob }) => {
          const url = URL.createObjectURL(blob);
          
          // 다운로드 링크 생성
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          
          // 링크 클릭하여 다운로드 시작
          link.click();
          
          // 더 이상 필요 없는 URL 객체 제거
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `치과청구확인서 다운로드`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //push 구독 정보 저장(갱신)
      async insertSubscribe(context, data){
        axios.post(`/subscribe`, {
                                    'user_id': context.rootState.login.loginID
                                    ,'config': JSON.stringify(data)
                                  }, {
                                    headers: {
                                                'Authorization': context.rootGetters.getCryptNum
                                    }
                                  })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `push 서비스 구독`
                                        ,'alertContent': res.data.message});
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `push 서비스 구독`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //상태 정보 조회
      async getStatusInfo(context){
        axios.get(`/statusInfo/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setStatusInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '상태 정보 조회'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //지역 정보 조회
      async getRegionInfo(context){
        axios.get(`/region/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('getRegionInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '지역 정보 조회'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //치과 정보 조회
      async getHospitalInfo(context){
        axios.get(`/hospital/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('getHospitalInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '치과 정보 조회'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
      
      //치과 DB 할당
      async insertRegistDB(context, data){
        let dt = new Date().toLocaleString();

        axios.post('/regist-db/insert', {
          _id: `${data.planner}_${data.year}_${data.month}`
          ,year: data.year
          ,month: data.month
          ,planner: data.planner
          ,insert_date: dt
          ,insert_id: context.rootState.login.loginID
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result === 'success') {
            context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `DB 할당`
                                        ,'alertContent': res.data.message});
          } else {
            context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `DB 할당`
                                        ,'alertContent': res.data.message});
          }
                                        
          context.dispatch('getRegistDB', {planner: data.planner.planner_name});
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `DB 할당`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //치과 DB 요청 및 할당 현황 조회
      async getAllRequestDB(context, data){
        axios.get(`/request-db/list/all?y=${data.year}&m=${data.month}`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('getAllRequestDB', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '치과 DB 요청 및 할당 현황 조회'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //치과 DB 요청 건수 조회
      async getRequestDB(context){
        axios.get(`/request-db/list?n=${context.rootState.login.userName}`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('getRequestDB', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': 'DB 요청 건수 조회'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //치과 DB 건수 요청
      async insertRequestDB(context, data){
        let dt = new Date().toLocaleString();

        axios.post('/request-db/insert', {
          _id: `${context.rootState.login.userName}_${data.year}_${data.month}`
          ,planner: context.rootState.login.userName
          ,year: data.year
          ,month: data.month
          ,count: data.count
          ,insert_date: dt
          ,insert_id: context.rootState.login.loginID
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `DB 요청`
                                        ,'alertContent': res.data.message});
          context.dispatch('getRequestDB');
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `DB 요청`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //치과 정보 입력
      async insertHospital(context, data){
        axios.post('/hospital/insert', {
          content: JSON.stringify(data.hospital[0])
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result === 'success') {
            context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `치과 정보 입력`
                                        ,'alertContent': res.data.message});
          } else {
            context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `치과 정보 입력`
                                        ,'alertContent': res.data.message});
          }
          context.dispatch('getHospitalInfo');
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `치과 정보 입력`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //치과 정보 삭제
      async deleteHospital(context, data){
        axios.post('/hospital/delete', {
          name: data.name
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result === 'success') {
            context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `치과 정보 삭제`
                                        ,'alertContent': res.data.message});
          } else {
            context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `치과 정보 삭제`
                                        ,'alertContent': res.data.message});
          }
          context.dispatch('getHospitalInfo');
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `치과 정보 삭제`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //운영DB -> 개발DB 이관
      async migration(context, data) {
        axios.post(`/migration`, { 'kind': data }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `개발용 작업: ${data}`
                                        ,'alertContent': res.data.message});
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `개발용 작업: ${data}`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //DB 초기화
      async reset(context, data){
        axios.post(`/reset`, { 'kind': data }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `개발용 작업: ${data}`
                                        ,'alertContent': res.data.message });
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `개발용 작업: ${data}`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      // 서버 관리
      async serverManage(context, data) {
        axios.post(`/server/manage`, { 'kind': data }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('setAlert', {  'alertStatus': 'notice'
                                        ,'alertTitle': `개발용 작업: ${data}`
                                        ,'alertContent': res.data.message });
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': `개발용 작업: ${data}`
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //공지사항 노출 여부 변경
      // async toggleNoticeModal(context){
      //   axios.post('/toggleNoticeModal')
      //   .then((res) => {
      //     context.commit('setAlert', {  'alertStatus': 'notice'
      //                                   ,'alertTitle': `개발용 작업: toggleNoticeModal`
      //                                   ,'alertContent': res.data.message });
      //   })
      //   .catch((error) => {
      //     context.commit('setAlert', {  'alertStatus': 'error'
      //                                   ,'alertTitle': `개발용 작업: toggleNoticeModal`
      //                                   ,'alertContent': `오류 발생|${error}`});
      //   })
      // }
    },
  
    getters: {
      getCompleteTotalRatio(state){
        let complete = state.itsmInfoOrigin.filter((a) => (a.complete == 1 || a.complete == 5)).length;
        let total = state.itsmInfoOrigin.length;
        return `${complete}/${total}`;
      },

      //상태 정보
      getStatusInfo(state){
        return state.statusInfo;
      },

      //지역 정보
      getRegionInfo(state){
        return state.regionInfo;
      },

      //치과 정보
      getHospitalInfo(state){
        return state.hospitalInfo;
      },

      //치과 DB 요청 및 할당 현황 조회
      getAllRequestDB(state){
        return state.allRequestDB;
      },
      
      //치과 DB 요청 건수
      getRequestDBCount(state){
        return state.requestDB;
      },

      //치과청구확인서 정보
      getDentalFormInfo(state) {
        let result = [];
        let text = state.dentalFormSearchText.toLowerCase();

        if(state.dentalFormSearchText != '') {
          state.dentalFormInfo.forEach(a => {
            if(decodeURIComponent(a.file_name).toLowerCase().indexOf(text) > -1) {
              result.push(a);
            }
          });
        } else {
          return state.dentalFormInfo;
        }

        return result;
      },

      //통계-치과별 등록 건수
      getStatisticsDentalCount(state, getters, rootState){
        let temp = {};
        let totalCount = 0;
        let sDt = state.period[0];
        let eDt = state.period[1];
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = +(new Date(eDt.toLocaleDateString()).getTime()) + 86400000; //종료일에 하루 더해서 계산.

        rootState.customer.dCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime(); //등록일
          let hospital = cur.hospital_info.hospital;
          
          if(!temp[hospital]){
            temp[hospital] = {hospital: hospital, count: 0};
          }
          
          //등록일 포함
          if(sTime <= ins_dt && ins_dt < eTime){
            temp[hospital].count = +temp[hospital].count + 1;
            totalCount += 1;
          }

        }, 0);

        //0건 삭제
        let result = [];
        Object.keys(temp).forEach((val) => {
          if(temp[val].count !== 0){
            result.push(temp[val]);
          }
        });

        //정렬
        result.sort((a, b) => {
          if(+(b.count) > +(a.count)) return 1;
          if(+(b.count) < +(a.count)) return -1;
          
          return 0;
        })

        return [result, totalCount];
      },

      //통계-플래너별 등록 건수/체결액
      getStatisticsPlannerCount(state, getters, rootState){
        let temp = {};
        let totalCount = 0;
        let totalPrice = 0;
        let totalReside = 0;
        let sDt = state.period[0];
        let eDt = state.period[1];
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = +(new Date(eDt.toLocaleDateString()).getTime()) + 86400000; //종료일에 하루 더해서 계산.

        rootState.customer.dCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime(); //등록일
          let planner = cur.planner.planner01.planner_name;
          let isReside = cur.isReside;
          
          if(!temp[planner]){
            temp[planner] = {
              planner: planner
              ,count: 0
              ,price: 0
              ,reside: 0
            };
          }

          //등록일 포함
          if(sTime <= ins_dt && ins_dt < eTime){
            temp[planner].count = +temp[planner].count + 1;
            if(isReside){
              temp[planner].reside = +temp[planner].reside + 1;
              totalReside += 1;
            }
            totalCount += 1;
          }

          //체결액 정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';
            
            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }

            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              temp[planner].price = +temp[planner].price + +(cur.contract[i].price.replaceAll(',', ''));
              totalPrice += +(cur.contract[i].price.replaceAll(',', ''));
            }
          }

        }, 0);

        //0건 삭제
        let result = [];
        Object.keys(temp).forEach((val) => {
          if((temp[val].count !== 0 || temp[val].price !== 0) ){
            result.push(temp[val]);
          }
        });

        //정렬
        result.sort((a, b) => {
          //건수
          if(+(b.count) > +(a.count)) return 1;
          if(+(b.count) < +(a.count)) return -1;

          //체결액
          if(+(b.price) > +(a.price)) return 1;
          if(+(b.price) < +(a.price)) return -1;
          
          return 0;
        })

        return [result, totalCount, totalPrice, totalReside];
      },

      //통계-플래너별 컴플레인/처리 건수
      getStatisticsComplainCount(state, getters, rootState){
        let temp = {};
        let totalComplain = 0;
        let totalDefault = 0;
        let totalProcess = 0;
        let totalResult = 0;
        let totalImposible = 0;
        let sDt = state.period[0];
        let eDt = state.period[1];
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = +(new Date(eDt.toLocaleDateString()).getTime()) + 86400000; //종료일에 하루 더해서 계산.

        rootState.customer.dCustomerInfoOrigin.reduce((_, cur) => {
          let planner = cur.planner.planner01.planner_name;
          
          if(!temp[planner]){
            temp[planner] = {
              planner: planner
              ,contents: []
              ,complain: 0
              ,default: 0
              ,process: 0
              ,result: 0
              ,imposible: 0
            };
          }

          for(let i = 0; i < cur.complain.length; i++){
            let regDt = new Date(cur.complain[i].regDt).getTime(); //컴플레인 등록일
            let status = cur.complain[i].status; //컴플레인 처리 상태(D: 기본값, C: 확인전, P: 처리중, S: 처리완료, X: 처리불가 )
            let statusText = '확인전';

            if(sTime <= regDt && regDt < eTime){
              //컴플레인 등록 건수
              temp[planner].complain = +temp[planner].complain + 1;
              totalComplain++;

              //처리 상태
              switch(status){
                case 'D':
                case 'C':
                    temp[planner].default = +temp[planner].default + 1;
                    totalDefault++;
                    statusText = '확인전';
                  break;
                case 'P':
                    temp[planner].process = +temp[planner].process + 1;
                    totalProcess++;
                    statusText = '처리중';
                  break;
                case 'S':
                    temp[planner].result = +temp[planner].result + 1;
                    totalResult++;
                    statusText = '처리완료';
                  break;
                case 'X':
                    temp[planner].imposible = +temp[planner].imposible + 1;
                    totalImposible++;
                    statusText = '처리불가';
                  break;
                default:
                  break;
              }
              
              //컴플레인 내용
              temp[planner].contents.push('(' + statusText + ')' + cur.name + ' 고객: ' + cur.complain[i].content);
            }
          }
        }, 0);

        //0건 삭제
        let result = [];
        Object.keys(temp).forEach((val) => {
          if(temp[val].complain !== 0){
            result.push(temp[val]);
          }
        });

        //정렬
        result.sort((a, b) => {
          //건수
          if(+(b.complain) > +(a.complain)) return 1;
          if(+(b.complain) < +(a.complain)) return -1;

          //처리완료 건수
          if(+(b.result) > +(a.result)) return 1;
          if(+(b.result) < +(a.result)) return -1;
          
          return 0;
        })
        
        return [result, totalComplain, totalDefault, totalProcess, totalResult, totalImposible];
      },
    }
  }

  export default commonStore;